import { render, staticRenderFns } from "./AreaAssetEdit.vue?vue&type=template&id=a255ba38"
import script from "./AreaAssetEdit.vue?vue&type=script&lang=js"
export * from "./AreaAssetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports